export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=33059be0&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/pages/lk/materials/index.vue?vue&type=template&id=33059be0&
// module id = 1181
// module chunks = 0